// Single source of truth for supported countries + their default language.
// Used by the global Country/Language selector, WhoPays, Resources, Treatments.
//
// Each entry:
//   code        — ISO-3166-1 alpha-2
//   label       — English display name (we keep the country list in English
//                 even when the UI is translated so a Spanish-speaking user
//                 in Mexico can still scan the list)
//   flag        — unicode flag (used purely visually)
//   defaultLang — language we suggest when the user switches to this country.
//                 They can still override the language independently.

export const SUPPORTED_COUNTRIES = [
    { code: "US", label: "United States", flag: "🇺🇸", defaultLang: "en" },
    { code: "CA", label: "Canada", flag: "🇨🇦", defaultLang: "en" },
    { code: "MX", label: "Mexico", flag: "🇲🇽", defaultLang: "es" },
    { code: "GB", label: "United Kingdom", flag: "🇬🇧", defaultLang: "en" },
    { code: "IE", label: "Ireland", flag: "🇮🇪", defaultLang: "en" },
    { code: "AU", label: "Australia", flag: "🇦🇺", defaultLang: "en" },
    { code: "NZ", label: "New Zealand", flag: "🇳🇿", defaultLang: "en" },
    { code: "DE", label: "Germany", flag: "🇩🇪", defaultLang: "de" },
    { code: "FR", label: "France", flag: "🇫🇷", defaultLang: "fr" },
    { code: "ES", label: "Spain", flag: "🇪🇸", defaultLang: "es" },
];

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "fr", label: "Français" },
    { code: "de", label: "Deutsch" },
];

export function countryMeta(code) {
    return SUPPORTED_COUNTRIES.find((c) => c.code === (code || "").toUpperCase()) || SUPPORTED_COUNTRIES[0];
}

export function languageMeta(code) {
    return SUPPORTED_LANGUAGES.find((l) => l.code === (code || "").toLowerCase()) || SUPPORTED_LANGUAGES[0];
}
